module.exports = {"id":"204542","name":"Yoshimar Yotún","rating":"71","photo":"./data/images/photos/1/204542.png","club":{"name":"Orlando City","logo":"./data/images/clubs/OrlandoCity.png"},"positions":["MC","MG","DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YoshimarYotun0.json
// module id = 4426
// module chunks = 0